export default __webpack_public_path__ + "static/media/exceptional@3x.a7b7952d.png";